import React, { Component } from 'react';
import './pageProgress.scss';

class PageProgress extends Component {
  state = {
    width: null,
  };

  watchScrolling = () => {
    const { scrollHeight, clientHeight, scrollTop } = document.documentElement;
    const winScroll = document.body.scrollTop || scrollTop;
    const height = scrollHeight - clientHeight;
    const scrolled = `${(winScroll / height) * 100}%`;
    if (height > 0) {
      return this.setState({ width: scrolled });
    } else {
      return this.setState({ width: 0 });
    }
  };

  componentDidMount() {
    window.addEventListener('scroll', this.watchScrolling);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.watchScrolling);
  }

  render() {
    const { width } = this.state;
    const styles = {
      progress: {
        width: width,
      },
    };
    return <div className="page-progress" style={styles.progress} />;
  }
}

export default PageProgress;
